export default "__VITE_ASSET__DVyJFWfZ__"